import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import { BudgetTypes } from '../../enums';
import { CartItem, CartSummaryModel } from '../../models/Cart';

interface ICartService {
  getCartItems: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<CartItem[]>>;
  removeProduct: (
    cartItemId: number,
  ) => Promise<HttpResponse<CartSummaryModel>>;
  toggleUseBenefitBudgetProduct: (
    cartItemId: number,
  ) => Promise<HttpResponse<CartSummaryModel>>;
  editCartItem: (
    cartItemId: number,
    quantity: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<CartSummaryModel>>;
  addProduct: (
    productId: number,
    quantity: number,
    cashbackDiscount: number,
    options: any,
    selectedCheckoutMethod?: BudgetTypes,
    isSalaryDeductionSelected?: boolean,
  ) => Promise<HttpResponse<CartItem[]>>;
  undoRemoveProduct: (
    productId: number,
    quantity: number,
    options: any,
  ) => Promise<HttpResponse<CartSummaryModel>>;
  getCart: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<CartSummaryModel>>;
}

export const cartService: ICartService = {
  getCartItems(axiosConfig) {
    return ajax.get<CartItem[]>(`${config.benefitApiUrl}/cart`, axiosConfig);
  },
  removeProduct(cartItemId) {
    return ajax.delete(`${config.benefitApiUrl}/cart/${cartItemId}`);
  },
  toggleUseBenefitBudgetProduct(cartItemId) {
    return ajax.put(
      `${config.benefitApiUrl}/cart/toggle-use-benefit-budget?cartItemId=${cartItemId}`,
    );
  },
  editCartItem(cartItemId, quantity, axiosConfig) {
    return ajax.patch(
      `${config.benefitApiUrl}/cart`,
      { cartItemId, quantity },
      axiosConfig,
    );
  },
  addProduct(
    productId,
    quantity,
    cashbackDiscount,
    options,
    selectedCheckoutMethod,
    isSalaryDeductionSelected,
  ) {
    return ajax.post(`${config.benefitApiUrl}/cart`, {
      productId,
      quantity,
      cashbackDiscount,
      options,
      selectedCheckoutMethod,
      isSalaryDeductionSelected,
    });
  },
  undoRemoveProduct(productId, quantity, options) {
    return ajax.post(`${config.benefitApiUrl}/cart/undo-remove-product`, {
      productId,
      quantity,
      options,
    });
  },
  getCart(axiosConfig) {
    // If null, send isInitialLoad=true (first load)
    return ajax.get<CartSummaryModel>(
      `${config.benefitApiUrl}/cart/summary`,
      axiosConfig,
    );
  },
};
